import React, { useRef, useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import Arrow from '@components/Carousel/components/Arrow';
import MenuItem, { MenuItemLoading } from '../components/MenuItem';

const HeaderCollectionsDesktop = ({ menuList }) => {
  const wrapperRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderRef, instanceRef] = useKeenSlider({
    rubberband: false,
    loop: true,
    slides: { perView: 'auto' },
    renderMode: 'custom',

    detailsChanged(s) {
      const containerWidth = s.container.offsetWidth;
      s.slides.forEach((slide, idx) => {
        slide.style.left = `${
          s.track.details.slides[idx].distance * containerWidth
        }px`;
      });
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setTimeout(() => {
        instanceRef?.current?.update();
        setLoaded(true);
      }, 500);
    }
  });
  // возможно исправить
  // useEffect(() => {
  //   const bonds = wrapperRef?.current?.getBoundingClientRect();
  //   if (!loaded && wrapperRef.current && instanceRef.current && bonds?.width) {
  // setTimeout(() => {
  //   instanceRef?.current?.update();
  //   setLoaded(true);
  // }, 500);
  //   }
  // }, [ wrapperRef.current, instanceRef.current ]);

  const onLeftArrowClick = e => {
    e.stopPropagation();
    if (instanceRef.current?.track?.details) {
      const { rel } = instanceRef.current.track.details;
      const prevInd = rel - 3 < 0 ? 0 : rel - 3;
      instanceRef.current?.moveToIdx(prevInd);
    }
  };
  const onRightArrowClick = e => {
    e.stopPropagation();
    if (instanceRef.current?.track?.details) {
      const { maxIdx, rel } = instanceRef.current.track.details;
      const nextInd = maxIdx - rel > 3 ? rel + 3 : rel + (maxIdx - rel);
      instanceRef.current?.moveToIdx(nextInd);
    }
  };
  return (
    <div className='HeaderCollections'>
      <div ref={wrapperRef} className='HeaderCollections__wrapper'>
        {menuList.length > 0 ? (
          <div
            ref={sliderRef}
            className='keen-slider'
            style={{ height: '20px' }}
          >
            {menuList?.map((item, index) => (
              <div
                key={item.id}
                style={{
                  position: 'absolute',
                  width: 'auto',
                  display: 'flex',
                  height: '20px'
                }}
                className='keen-slider__slide'
              >
                <MenuItem
                  icon={item.icon}
                  link={item.link}
                  title={item.title}
                  isLast={index === menuList.length - 1}
                  isRed={index === 0}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className='keen-slider' style={{ height: '20px' }}>
            {Array.from({ length: 5 }).map((_, index) => (
              <MenuItemLoading key={`loading-${index}`} />
            ))}
          </div>
        )}
        {loaded && instanceRef && (
          <>
            {currentSlide !== 0 && (
              <Arrow
                className='HeaderCollections__arrow'
                left
                onClick={onLeftArrowClick}
              />
            )}
            {instanceRef.current?.track.details.maxIdx !==
              instanceRef.current?.track.details.abs && (
              <Arrow
                className='HeaderCollections__arrow HeaderCollections__arrow--right'
                onClick={onRightArrowClick}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderCollectionsDesktop;
